import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SitemapPageToken } from '@sleed/bizcommerce-api';
import { sitemapPagesApi } from '~/lib/api/client';
import { formToToken, type SitemapPageFormValues } from '~/lib/schemas/sitemap-page';

export const sitemapPageKeys = { all: ['sitemap-pages'] as const, list: () => [...sitemapPageKeys.all, 'list'] as const };

export function useSitemapPagesList() {
	return useQuery<SitemapPageToken[]>({
		queryKey: sitemapPageKeys.list(),
		queryFn: async () => (await sitemapPagesApi.getAll()).data.items ?? []
	});
}

export function useSitemapPageMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: sitemapPageKeys.list() });
	const create = useMutation({
		mutationFn: async (form: SitemapPageFormValues) => (await sitemapPagesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: SitemapPageFormValues) => (await sitemapPagesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await sitemapPagesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
